/**
 * Adapptio Core Library
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import {
	ISchemaConstObject,
	ISchemaValue,
	TGenericBlueprintSchema,
	TRuntimeContextRenderFunction,
	TSchemaConstObjectProps
} from "@adapptio/lib-blueprint";
import { ISchemaImportExport } from "@adapptio/lib-blueprint";
import { ItemRegistry } from "@adapptio/lib-shared";
import { IBlueprintRegistryItemProps } from "../blueprints";

/**
 * View Instance props
 */
export interface IViewInstanceProps extends IBlueprintRegistryItemProps {
	/** Params schema */
	paramsSchema: ISchemaValue<ISchemaConstObject<TSchemaConstObjectProps>>;

	/** Render function */
	renderFunction?: TRuntimeContextRenderFunction<TGenericBlueprintSchema>;

	/** Export data for paramSchema */
	paramsSchemaExport?: ISchemaImportExport;

	/** Compiled view schema */
	compiledCode?: string;

	/** If view requires authenticated user to access it */
	requireAuthenticatedUser: boolean;

	/** If the view instance is valid and fully loaded */
	isValid: boolean;
}

export type IViewRegistry = ItemRegistry<IViewInstanceProps>;

export class ViewRegistry extends ItemRegistry<IViewInstanceProps> {}
